export default "__VITE_ASSET__beed2c53__"